module.exports = __webpack_public_path__ + "static/media/clases-4.8412f245.jpg";